<ng-container *ngFor="let button of actionButtons; let i = index">
  <ng-container *ngIf="button.hideFunction && model? !button.hideFunction(model) :true ">
    <ng-container *ngIf="button.showFunction && model? button.showFunction(model) :true ">
      <ng-container *ngIf="!button.hide && button.visible !=false">
        <ng-container *ngxPermissionsOnly="button.permissions ?? []">
          <ng-container *ngIf="loadingBtnAction[data?.uid] !== true">
            <ng-container *ngIf="!button?.buttons?.length; else menuTriggerButton">
              <div (click)="action(button)" [matTooltip]="button.toolTip ?? button.label"
                   class=" {{buttonHolderClass}} {{animation}} --order-{{index+i+1}} ">
                <ng-container *ngTemplateOutlet="buttonTpl;context:{button}"></ng-container>
              </div>
            </ng-container>
          </ng-container>
          <mat-progress-bar *ngIf="loadingBtnAction[data?.uid]" [mode]="'indeterminate'"
                            [value]="10"></mat-progress-bar>

          <ng-template #menuTriggerButton>
            <div [matMenuTriggerFor]="menu" [matTooltip]="button.toolTip ?? button.label"
                 class="{{buttonHolderClass}} {{animation}} --order-{{index+i+1}}">
              <ng-container *ngTemplateOutlet="buttonTpl; context:{button}"></ng-container>
            </div>

            <mat-menu #menu="matMenu">
              <div class="mx-1">
                <action-buttons [actionButtons]="button.buttons" [data]="data" [model]="model"
                                [onMenu]="true" buttonHolderClass="flex-col gap-1"
                ></action-buttons>
              </div>
            </mat-menu>
          </ng-template>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #buttonTpl let-button="button">
  <ng-container
    *ngIf="button.class ?? ((button.type | valueIncludes:'fab') && !button.disabled ? fabClass :'b') as c">
    <ng-container *ngIf="button.type==='button' || !button.type">
      <button [disabled]="button.disabled" [ngClass]="{'!border-none w-full !flex !justify-start':onMenu}"
              class="{{c}}" mat-flat-button>
        <ng-container *ngTemplateOutlet="iconTpl;
          context:{button, class:button.label? 'align-bottom me-2':''}">
        </ng-container>
        <span *ngIf="button.label" [innerHTML]="button.label " class="align-middle "></span>
      </button>
    </ng-container>

    <ng-container *ngIf="button.type==='fab'">
      <button [disabled]="button.disabled" class="{{c}}" mat-fab>
        <ng-container *ngTemplateOutlet="iconTpl; context:{button, class:''}"></ng-container>
      </button>
    </ng-container>

    <ng-container *ngIf="button.type==='mini-fab'">
      <button [disabled]="button.disabled" class="{{c}}" mat-mini-fab>
        <ng-container *ngTemplateOutlet="iconTpl; context:{button, class:'icon-smalll'}"
        ></ng-container>
      </button>
    </ng-container>

    <ng-container *ngIf="button.type==='icon'">
      <button [disabled]="button.disabled" class="{{c}}" mat-icon-button>
        <ng-container *ngTemplateOutlet="iconTpl; context:{button, class:''}"
        ></ng-container>
      </button>
    </ng-container>

    <ng-container *ngIf="button.type==='mini-icon'">
      <button [disabled]="button.disabled" class="{{c}} bg-none shadow-none" mat-mini-fab>
        <ng-container *ngTemplateOutlet="iconTpl; context:{button, class:'icon-small'}"
        ></ng-container>
      </button>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #iconTpl let-button="button" let-class="class">
  <ng-container *ngIf="button?.icon | iconType as type">
    <mat-icon *ngIf="type==='SVG'" [svgIcon]="button.icon" class="{{class}} {{button.iconClass}}"></mat-icon>
    <mat-icon *ngIf="type==='MATERIAL'" class="{{class}} {{button.iconClass}}">
      {{ button.icon }}
    </mat-icon>
  </ng-container>
</ng-template>
